module.exports = __webpack_public_path__ + "static/media/expressjs-icon.9de32921.svg";